import './index.scss';
import '/node_modules/react-grid-layout/css/styles.css';
import '/node_modules/react-resizable/css/styles.css';
import '@fontsource-variable/roboto-mono';
import '@fontsource/space-mono';

import { ChakraProvider, Spinner } from '@chakra-ui/react';
import { persistor, store } from '@redux/store';
import { ErrorInfo, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { MapProvider } from 'react-map-gl/mapbox';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';

import App from './components/App';
import ModalsProvider from './components/common/modals/ModalsProvider';
import MessagesProvider from './components/locale/MessageProvider';
import ErrorPage from './ErrorPage';
import { system } from './theme/theme';

const domNode = document.getElementById('root')!;
const root = createRoot(domNode);

function logErrorToService(error: unknown, info: ErrorInfo) {
  console.error('Caught an error:', error, info);
}

root.render(
  <StrictMode>
    {/*<ColorModeScript initialColorMode={theme.config.initialColorMode} />*/}
    <ErrorBoundary fallback={<ErrorPage />} onError={logErrorToService}>
      <Provider store={store}>
        <ChakraProvider value={system}>
          <PersistGate loading={<Spinner size="xl" />} persistor={persistor}>
            <MessagesProvider>
              <BrowserRouter>
                <ModalsProvider>
                  <MapProvider>
                    <App />
                  </MapProvider>
                </ModalsProvider>
              </BrowserRouter>
            </MessagesProvider>
          </PersistGate>
        </ChakraProvider>
      </Provider>
    </ErrorBoundary>
  </StrictMode>,
);
